{
  "featuredSermon": "Prédication à l'affiche",
  "discussionQuestions": "Questions de discussion",
  "details": "Détails"
}
